// extracted by mini-css-extract-plugin
module.exports = {"bulkPreviewPage":"UploadBulkPreview_bulkPreviewPage__3PcD3","header":"UploadBulkPreview_header__1ugIC","cancelButton":"UploadBulkPreview_cancelButton__11U-B"};